<template>
  <div>
    <register-header :state="2" />
    <div class="forget-content">

      <el-form ref="form" class="forget-box" :model="form" :rules="rules" label-width="100px">
        <span class="box-title">忘记密码</span>
        <el-form-item label="短信验证码" prop="code">
          <div class="captcha-container">
            <el-input
              v-model="form.code"
              placeholder="请输入您收到的验证码"
              maxlength="6"
              size="medium"
              clearable
            />
            <div class="box-captcha box-code" :class="countdown ? 'box-pointer-no' : 'box-pointer'" @click="getPhoneCode">
              {{ secondTxt }}
            </div>
          </div>
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input
            v-model="form.password"
            type="password"
            placeholder="8-20位，必须包含大小写字母、字符或数字的至少三种"
            :maxlength="20"
            size="medium"
            auto-complete="new-password"
            clearable
          />
        </el-form-item>
        <el-form-item label="确认新密码" prop="repeat">
          <el-input
            v-model="form.repeat"
            type="password"
            placeholder="8-20位，必须包含大小写字母、字符或数字的至少三种"
            :maxlength="20"
            size="medium"
            clearable
          />
        </el-form-item>
        <div class="box-submit" @click="handleSubmit">确认修改</div>
      </el-form>
    </div>
  </div>
</template>

<script>
import Qs from 'qs'
import RegisterHeader from './RegisterHeader.vue'
import { getResetPwdAuthCode, resetPassword } from '@/api/member.js'
import JSEncrypt from 'jsencrypt'

const jsencrypt = new JSEncrypt()
const rsaPublicKey =
  'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCMFYpa2y3AU9GnTQgmgjjWjNNsUBxuR5pNpAVBHpZ/PS49a/E9jX6rNabnR/lfkOM7BoCIcizzLln8EYUmqpME7+Eq/nk4F18q1R9apfjiDkRx/3tzxslrA4ZHHV2gBpRyUDxew4YceAHpDoVgZGWMseqLXHCvGzmogtF87cVbuwIDAQAB'
jsencrypt.setPublicKey(rsaPublicKey)

export default {
  name: 'ForgetPassword2',
  components: { RegisterHeader },
  data() {
    // 校验密码
    const validatePassword = (rule, value, callback) => {
      // 小写字母
      const regLowerLetter = /[a-z]/
      // 大写字母
      const regUpperLetter = /[A-Z]/
      // 数字
      const regNum = /[0-9]/
      // 特殊字符
      const regCharacter = /[*?!&￥$%^#,./@';:><\[\]}{\-=+_\\|》《。，、？’‘“”~ `]/
      const regRes = [regLowerLetter, regUpperLetter, regNum, regCharacter].filter(item => item.test(value))
      if (regRes.length < 3) {
        return callback(new Error('密码须包含大小写字母、字符或数字的至少三种'))
      }
      if (this.form.repeat && value !== this.form.repeat) {
        return callback(new Error('两次密码输入不一致'))
      }
      callback()
    }
    // 校验二次确认密码
    const validateRepeat = (rule, value, callback) => {
      if (this.form.password && value !== this.form.password) {
        return callback(new Error('两次密码输入不一致'))
      }
      callback()
    }
    return {
      phone: '',
      username: '',
      countdown: null,
      secondTxt: '获取验证码',
      form: {
        code: '',
        password: '',
        repeat: ''
      },
      rules: {
        code: [
          { required: true, message: '请输入短信验证码', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 8, message: '请输入至少8位密码', trigger: 'blur' },
          { validator: validatePassword, trigger: 'blur' }
        ],
        repeat: [
          { required: true, message: '请确认密码', trigger: 'blur' },
          { validator: validateRepeat, trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.phone = this.$route.params.phone
    this.username = this.$route.params.username
    this.getPhoneCode()
  },
  destroyed() {
    clearInterval(this.countdown)
  },
  methods: {
    // 短信验证码倒计时
    startCountdown() {
      let sec = 60
      this.secondTxt = sec + '后重试'
      this.countdown = setInterval(() => {
        if (sec > 1) {
          sec--
          this.secondTxt = sec + '后重试'
        } else {
          clearInterval(this.countdown)
          this.countdown = null
          this.secondTxt = '获取验证码'
        }
      }, 1000)
    },
    // 获取短信验证码
    async getPhoneCode() {
      if (this.phone && this.username && !this.countdown) {
        const params = {
          telephone: this.phone,
          username: this.username
        }
        const res = await getResetPwdAuthCode(Qs.stringify(params))
        if (res.code === 200) {
          this.$Message.success('短信验证码已发送')
          this.startCountdown()
        } else {
          this.$router.push('/forgetPassword1')
        }
      } else {
        this.$Message.error('参数非法')
      }
    },
    // 确认修改
    async handleSubmit() {
      this.$refs['form'].validate(async(valid) => {
        if (valid) {
          const params = {
            authCode: this.form.code,
            password: jsencrypt.encrypt(this.form.password),
            telephone: this.phone,
            username: this.username
          }
          const res = await resetPassword(Qs.stringify(params))
          if (res.code === 200) {
            this.$Message.success('密码重置成功，请重新登录')
            setTimeout(() => {
              this.$router.push('/login')
            }, 1000)
          } else {
            this.$router.go(-1)
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.captcha-container {
  display: flex;
  align-items: center;
}
.forget-content {
  background-color: #f5f5f5;
  padding: 36px 0;
}
.forget-box {
  margin: 0 auto;
  width: 700px;
  background-color: white;
  border-radius: 6px;
  display: flex;
  flex-direction: column;
  padding: 30px 68px;
}
.box-title {
  text-align: center;
  font-size: 20px;
  font-weight: bold;
  color: #3d3d3d;
  margin-bottom: 15px;
}
.box-pointer {
  cursor: pointer;
}
.box-pointer-no {
  cursor: default;
}
.box-code {
  border-radius: 4px;
  border: 1px solid #f6713d;
  color: #f6713d;
  font-size: 14px;
  text-align: center;
  line-height: 36px;
  height: 36px;
  width: 130px;
  margin-left: 12px;
}
.box-submit {
  margin-top: 20px;
  height: 42px;
  line-height: 42px;
  text-align: center;
  border-radius: 4px;
  background: #f6713d;
  color: white;
  font-size: 14px;
  cursor: pointer;
}
.el-input >>> .el-input__inner:focus {
  border-color: #f6713d;
}
</style>
